import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Menuitems } from '../../../../Interface/menuitems';
import { MasterInformationService } from '../../../Services/master-information.service';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../../Services/shared.service';
// import { AuthService } from '../../services/auth.service';

enum userType {
  SuperAdmin = 5,
}

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './sidnav.component.html',
  styleUrl: './sidnav.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SidenavComponent implements OnInit {
  @Input() isOpen = true;
  userRole: any;
  mainMenuList: any;
  subMenuList: any;
  menuMappingList: any;
  loginData: any;
  userType: any;
  menuItems: any;

  constructor(
    private masterService: MasterInformationService,
    private toastr: ToastrService,
    private sharedService: SharedService,
    private route: Router
  ) {}

  ngOnInit() {
    this.loginData = this.sharedService.getLoginData();
    this.userType = this.loginData?.userType;

    this.getMenuMapping();
  }

  toggleSubmenu(item: Menuitems): void {
    if (item.title == 'Order Approval') {
      this.route.navigate(['/baldia-approval'])
    }
    item.isSubmenuVisible = !item.isSubmenuVisible;
  }

  toggleGrandChild(submenu: any): void {
    submenu.isGrandChildVisible = !submenu.isGrandChildVisible;
  }

  getMenuMapping() {
    this.masterService
      .getMenuMappingList(apiEndPoints.getMenuMapping, this.userType)
      .subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            this.menuMappingList = response.body.details.filter(
              (map: any) => map.userType == this.userType
            );
            this.getMainMenuList();
          }
        },
        error: (error) => {
          console.error('Error fetching menu mapping:', error);
        },
      });
  }

  getMainMenuList() {
    this.masterService.getMainmenu(apiEndPoints.sideMenuList).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          let allMenus = response.body.details;

          this.mainMenuList = allMenus.filter((menu: any) =>
            this.menuMappingList.some(
              (map: any) =>
                menu.id == map.mainMenuId && map.userType == this.userType
            )
          );

          this.getSubmenuList();
        }
      },
      error: (error) => {
        this.toastr.error(
          'Error Getting MainMenu. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  /* Fetch Submenu List */

  getSubmenuList() {
    this.masterService.getSubmenu(apiEndPoints.subMenuList).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          let allSubmenus = response.body.details;
          this.subMenuList = allSubmenus.filter((submenu: any) =>
            this.menuMappingList.some(
              (map: any) =>
                submenu.id == map.subMenuId && map.userType == this.userType
            )
          );

          this.mapMenuWithSubmenu();
        }
      },
      error: (error) => {
        this.toastr.error(
          'Error Getting SubMenu. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  /*  Map Filtered Submenus to Filtered Main Menu */
  mapMenuWithSubmenu() {
    this.menuItems = this.mainMenuList.map((menu: any) => ({
      title: menu.menuName,
      route: menu.menuURL || '',
      icon: menu.menuIcon,
      isSubmenuVisible: false,
      submenus: this.subMenuList
        .filter((submenu: any) => submenu.mainMenuId === menu.id)
        .map((submenu: any) => ({
          title: submenu.subMenuName,
          route: submenu.subMenuUrl,
          isGrandChildVisible: false,
          grandChildMenus: [],
        })),
    }));
  }
}
